export default {
    data() {
        return {
            modificationPresent: typeof this.modification?.extras_result !== 'undefined' || this.modification?.extras?.length > 0,
            modificationSelected: null,
            count: 0,
        };
    },

    watch: {
        prepaySelected(value) {
            this.prepay = value === true ? 1 : 0;
        },
        modificationSelected() {
            this.modificationPresent = typeof this.modification?.extras_result !== 'undefined' || this.modification?.extras?.length > 0;
        },
    },
    computed: {
        min() {
            return Math.min.apply(Math, this.extra.choices);
        },
        max() {
            return Math.max.apply(Math, this.extra.choices);
        },
        selectedExtras() {
            return this.$store.getters.getSelectedExtras;
        },
        selectedCurrency() {
            return this.$store.getters.selectedCurrency;
        },
        pricePerDay() {
            return this.prepay ? this.extra.prepay_price_per_day : this.extra.price_per_day;
        },
        isSelected() {
            let selected = this.selectedExtras.filter((selectedExtra) => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            // If it's a booking modification, we also need to check if the extra is selected in the modification extras,
            // and add them to the selected array
            if (typeof this.modification !== 'undefined' && this.modification?.extras?.length > 0) {
                for (let i = 0; i < this.modification.extras.length; i++) {
                    if (this.modification.extras[i].id === this.extra.id || this.modification.extras[i].external_id === this.extra.external_id) {
                        selected.push(this.modification.extras[i]);
                    }
                }
            }

            return selected.length > 0;
        },
        choice() {
            const selectedExtraObjects = this.selectedExtras.filter((selectedExtra) => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            return selectedExtraObjects.length ? parseInt(selectedExtraObjects[0].choice) : 0;
        },
        bothPaymentOptionsAvailable() {
            return this.extra.prepay_available && this.extra.pay_on_arrival_available;
        },
        availablePaymentOptionLabel() {
            if (this.extra.pay_on_arrival_available) {
                return 'booking-process.shared.pay_on_arrival_label';
            }

            return 'booking-process.shared.pay_online_label';
        },
        prepaySelected() {
            const selectedExtraObjects = this.selectedExtras.filter((selectedExtra) => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            return selectedExtraObjects.length ? selectedExtraObjects[0].prepay : this.defaultPrepayValue;
        },
        defaultPrepayValue() {
            return this.extra.prepay_available;
        },
        numberStepperButtonLabel() {
            return this.isSelected ? 'booking-process.options_selection.remove_option_label' : 'booking-process.options_selection.add_option_label';
        },
        isFree() {
            let isFree = [];

            if (typeof this.selectedExtras !== 'undefined') {
                for (let i = 0; i < this.selectedExtras.length; i++) {
                    if (this.selectedExtras[i].quote_extra_id === this.extra.id && this.selectedExtras[i].free) {
                        isFree.push(this.selectedExtras[i]);
                    }
                }
            }

            if (typeof this.modification !== 'undefined' && typeof this.modification.extras !== 'undefined' && this.modification?.status === 'checked') {
                for (let i = 0; i < this.modification.extras.length; i++) {
                    if (this.modification?.extras[i].id === this.extra.id && this.modification?.extras[i].free) {
                        isFree.push(this.modification.extras[i]);
                    }
                }
            }

            return isFree.length > 0;
        },
    },

    methods: {
        /*
        |--------------------------------------------------------------------------
        | Booking mods: Step 3b - Choose Extras
        |--------------------------------------------------------------------------
        | When a user is modifying a booking and selects a new extra,
        | we send a request to the API, which will also send a simulation request (SIM)
        | to FMX to get the new pricing for the selected extra.
        */
        async toggleExtra(selected) {
            const isBeingModified = typeof this.modification !== 'undefined' && this.booking?.can_be_modified;
            const isFullModification = typeof this.modification !== 'undefined' && this.booking?.can_be_modified && this.quote.id !== this.booking.quote_id;

            // If we're partially modifying a booking (same quote), we just update the selected extra on the original quote
            if (typeof this.$route !== 'undefined' && this.$route.params.booking && this.quote?.id === this.booking?.quote_id) {
                // During a booking mod we need to temporarily disable the other extras,
                // so they don't interfere with the SIM request
                window.bus.$emit('prices-are-loading', true);
                window.bus.$emit('temporarilyDisableExtras', this.extra.id);
                window.bus.$emit('temporarilyDisableProducts');

                try {
                    const response = await this.$store
                        .dispatch('updateExtrasWithBooking', {
                            selected: selected,
                            extra: this.extra,
                            bookingId: this.booking.id,
                            booking_reference: this.booking.reference,
                            quoteId: this.quote.id,
                            modification: this.modification,
                        })
                        .then((response) => {
                            return response;
                        });

                    this.modificationSelected = false;

                    for (let i = 0; i < response.data.data[0].extras.length; i++) {
                        if (response.data.data[0].extras[i].id === this.extra.id) {
                            this.modificationSelected = true;
                        }
                    }
                } finally {
                    window.bus.$emit('prices-are-loading', false);
                    window.bus.$emit('enableExtras');
                    window.bus.$emit('enableProducts');
                }
            } else if (isBeingModified && isFullModification) {
                // During a booking mod we need to temporarily disable the other extras,
                // so they don't interfere with the SIM request
                window.bus.$emit('prices-are-loading', true);
                window.bus.$emit('temporarilyDisableExtras', this.extra.id);
                window.bus.$emit('temporarilyDisableProducts');

                try {
                    if (!selected) {
                        await this.$store.dispatch('createExtraForModification', {
                            extra: this.extra,
                            prepay: this.prepaySelected,
                            quote: this.quote,
                        });
                    } else {
                        await this.$store.dispatch('deleteExtraForModification', {
                            extra: this.extra,
                            quote: this.quote,
                        });
                    }

                    // If we're fully modifying a booking (new quote, which happens when selecting a new car),
                    // we update the selected extra on the modification quote
                    const response = await this.$store
                        .dispatch('updateExtrasWithBooking', {
                            selected: selected,
                            extra: this.extra,
                            bookingId: this.booking.id,
                            booking_reference: this.booking.reference,
                            quoteId: this.quote.id,
                            modification: this.modification,
                        })
                        .then((response) => {
                            return response;
                        });

                    this.modificationSelected = !selected;
                } finally {
                    window.bus.$emit('prices-are-loading', false);
                    window.bus.$emit('enableExtras');
                    window.bus.$emit('enableProducts');
                }
            } else {
                if (this.isSelected) {
                    return this.$store.dispatch('deleteExtra', this.extra);
                } else {
                    return this.$store.dispatch('createExtra', {
                        extra: this.extra,
                        prepay: this.prepaySelected,
                    });
                }
            }
        },
        updateExtraChoice(choice) {
            if (choice !== this.choice) {
                this.$store.dispatch('updateExtra', {
                    extra: this.extra,
                    choice: choice,
                    prepay: this.prepaySelected,
                });
            }
        },
        updateExtraPrepayStatus(prepay) {
            if (this.isSelected) {
                this.$store.dispatch('updateExtra', {
                    extra: this.extra,
                    prepay: prepay,
                });
            }
        },
        fixedPriceForBookingTerm(extra) {
            return extra.price_per_day === extra.total_price;
        },
    },
};
